var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_6833_1318)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "#E2E2E2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3254 17.0002L24.2251 11.1005C24.3959 10.9237 24.4904 10.6869 24.4882 10.4411C24.4861 10.1953 24.3875 9.96013 24.2137 9.78631C24.0399 9.61249 23.8047 9.51389 23.5589 9.51175C23.3131 9.50962 23.0763 9.60411 22.8995 9.77489L16.9998 15.6746L11.1001 9.77489C10.9233 9.60411 10.6865 9.50962 10.4407 9.51175C10.1949 9.51389 9.95973 9.61249 9.78591 9.78631C9.61209 9.96013 9.51349 10.1953 9.51136 10.4411C9.50922 10.6869 9.60372 10.9237 9.77449 11.1005L15.6742 17.0002L9.77449 22.8999C9.68495 22.9864 9.61353 23.0898 9.56439 23.2042C9.51526 23.3186 9.4894 23.4416 9.48832 23.5661C9.48723 23.6906 9.51096 23.814 9.55809 23.9292C9.60523 24.0444 9.67484 24.1491 9.76287 24.2371C9.85089 24.3252 9.95557 24.3948 10.0708 24.4419C10.186 24.489 10.3094 24.5128 10.4339 24.5117C10.5584 24.5106 10.6814 24.4847 10.7958 24.4356C10.9102 24.3865 11.0136 24.3151 11.1001 24.2255L16.9998 18.3258L22.8995 24.2255C23.0763 24.3963 23.3131 24.4908 23.5589 24.4886C23.8047 24.4865 24.0399 24.3879 24.2137 24.2141C24.3875 24.0403 24.4861 23.8051 24.4882 23.5593C24.4904 23.3135 24.3959 23.0767 24.2251 22.8999L18.3254 17.0002Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_6833_1318",
    x: -12,
    y: -12,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6833_1318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6833_1318",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossDark);
export default __webpack_public_path__ + "static/media/cross-dark.c5f392b5aee6a1f2748f07ad6f64063b.svg";
export { ForwardRef as ReactComponent };